import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc HearAboutUs - get All data
 */
export function getHearAboutUsAction() {
    let vendorId = localStorage.getItem("ID")

    let url = UrlConstants.hearAboutUsUrl;

    return function (dispatch) {
        return APIUtil.getMethod(url, true).then(response => {
            dispatch({
                type: types.GET_HEAR_ABOUT_US,
                hearAboutUs: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}

/**
 * @desc HearAboutUs - add data
 */
export function addHearAboutUsAction(data) {

    let url = UrlConstants.hearAboutUsUrl;

    return function (dispatch) {
        return APIUtil.postMethod(url, data, true).then(response => {
            dispatch({
                type: types.GET_HEAR_ABOUT_US,
                hearAboutUs: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}

/**
 * @desc HearAboutUs - delete data
 */
export function deleteHearAboutUsAction(id) {
    let url = UrlConstants.deleteHearAboutUsUrl + '/' + id;

    return function (dispatch) {
        return APIUtil.deleteMethod(url, true).then(response => {
            dispatch({
                type: types.GET_HEAR_ABOUT_US,
                hearAboutUs: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}


/**
 * @desc HearAboutUs - update data
 * 
 */
export function updateHearAboutUsAction(data, id) {
    let url = UrlConstants.updateHearAboutUsUrl + '/' + id;

    return function (dispatch) {
        return APIUtil.putMethod(url, data, true, "PATCH").then(response => {
            dispatch({
                type: types.GET_HEAR_ABOUT_US,
                hearAboutUs: response.status == code.OK ? response.data : []
            });
            return response.data || []
        });
    }
}